import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-price-list',
    templateUrl: './price-list.component.html',
    styleUrls: ['./price-list.component.css'],
    standalone: false
})
export class PriceListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
